module.exports = __webpack_public_path__ + "img/9_59.b2c3ef17.png";